module.exports = __webpack_public_path__ + "img/habitationpico.ad013797.png";